/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgNoteArrow = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M16 2v7h-2V4H4v16h10v-5h2v7H2V2z" />
        <path d="M22.395 12 18.8 15.697l-1.435-1.394L18.633 13H14v-2h4.633l-1.267-1.303 1.435-1.394zM12 15v2H6v-2zm0-4v2H6v-2zm0-4v2H6V7z" />
      </g>
    </g>
  </Icon>
);
export { SvgNoteArrow as NoteArrow };
